import { Box, Button, FormControl, Grid, IconButton, InputAdornment, Modal, OutlinedInput, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import { IconPlus } from '@tabler/icons';
import { useState } from 'react';
import CustomNoRowsOverlay from 'ui-component/customNoRowsOverlay';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddEditInvestmentsForm from './AddEditInvestmentsForm';
import { get, del } from '../../axios/apiService';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import { Modules } from 'store/constant';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

function Investments({ customerId }) {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [permissionMatrix, setPermissionMatrix] = useState({});
  const [isShowForm, setIsShowForm] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [open, setOpen] = useState(false);
  const [investments, setInvestments] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [sortModel, setSortModel] = useState([]);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleSortModelChange = (model) => {
    setSortModel(model);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const DeleteInvestments = async () => {
    try {
      if (deleteId) {
        await del(`Investments/${deleteId}`);
        setOpen(false);
        await fetchInvestments();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const ActionButtons = (row) => {
    return (
      permissionMatrix && permissionMatrix.writeRights === true ?
      <Stack direction={'row'} spacing={2}>
        <IconButton
          color="primary"
          size="large"
          onClick={() => {
            setEditId(row?.id);
            setIsShowForm(true);
            // handleClickOpen(row.id);
            // navigate(`/will-management/edit-insurance/${row.id}`);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color="error"
          size="large"
          onClick={() => {
            // if (confirm(`Are you sure, you want to delete "${row.userName}" User?`)) {
            //   DeleteUser(row.id);
            // }
            setDeleteId(row.id);
            setOpen(true);
            // setIsDeleteRoleId(row.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>:<></>
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      field: 'typeName',
      headerName: 'Type',
      flex: 1
    },
    { field: 'platform', headerName: 'Plat Form', flex: 1 },
    { field: 'bankOrCompanyName', headerName: 'Bank/CompanyName', flex: 1 },
    { field: 'accountNumber', headerName: 'Account Number', flex: 1 },
    {
      field: 'action',
      headerName: 'Actions',
      renderCell: (params) => <ActionButtons {...params.row} />,
      align: 'right',
      width: 120,
      sortable: false,
      filterable: false
    }
  ];

  const fetchInvestments = async () => {
    setLoading(true);
    try {
      const sortField = sortInvestmentsFiled(sortModel.length ? sortModel[0].field : '');
      const sortOrder = sortModel.length ? (sortModel[0].sort === 'asc' ? 'Ascending' : 'Descending') : '';
      const sortQuery = sortField != '' ? `&$orderby=${sortField}&$orderbydirection=${sortOrder}` : '';
      const searchQuery =
        search != '' ? `&$filter=platform~LIKE~${search} OR bankOrCompanyName~LIKE~${search} OR accountNumber~LIKE~${search}` : '';
      let response = await get(
        `Investments?$skip=${paginationModel.page * paginationModel.pageSize}&$top=${
          paginationModel.pageSize
        }${searchQuery}${sortQuery}&$customerId=${customerId}`
      );
      if (response) {
        setRowCount(response?.totalCount);
        setInvestments(response?.values);
      }
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvestments();
  }, [paginationModel, sortModel, search, isShowForm, customerId]);

  useEffect(() => {
    const UserPermissions = JSON.parse(localStorage.getItem(`UserPermissions`));
    const permission = UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Loans);
    if (permission) {
      setPermissionMatrix(permission);
    } else {
      setPermissionMatrix(null);
    }
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        {isShowForm ? (
          <AddEditInvestmentsForm id={editId} setIsShowForm={setIsShowForm} customerId={customerId} />
        ) : (
          <>
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0}>
                <form noValidate autoComplete="off" style={{ marginRight: 10 }}>
                  <FormControl sx={{ width: '25ch' }} size="small">
                    <OutlinedInput
                      placeholder="Search"
                      value={search}
                      onChange={handleSearchChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'grey'
                          },
                          '&:hover fieldset': {
                            borderColor: 'black'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'blue'
                          }
                        }
                      }}
                      endAdornment={
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </form>
                {permissionMatrix && permissionMatrix.writeRights === true ? (
                  <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (!customerId) {
                      toast.error('Please select a customer to add a investment.');
                      return; 
                    }
                    setEditId(null);
                    setIsShowForm(true);
                  }}
                  startIcon={<IconPlus />}
                >
                  Add
                </Button>
                ) : (
                  <></>
                )}
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={investments}
                rowCount={rowCount}
                columns={columns}
                paginationMode="server"
                sortingMode="server"
                pageSizeOptions={[10]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                components={{
                  NoRowsOverlay: CustomNoRowsOverlay
                }}
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
              />
            </Grid>
          </>
        )}
      </Grid>

      {/* Delete modal */}
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Typography sx={{ fontSize: '20px' }} id="modal-modal-title" variant="h6" component="h2">
            Delete Confirmation
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this record?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="error"
              sx={{ marginTop: '20px', marginRight: '20px', padding: '5px 30px' }}
            >
              Cancel
            </Button>
            <Button variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} onClick={DeleteInvestments}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
      <LoadingBackdrop open={isLoading} />
    </>
  );
}

export default Investments;

const sortInvestmentsFiled = (filed) => {
  if (filed == 'type') {
    return 'Type';
  } else if (filed == 'platform') {
    return 'Platform';
  } else if (filed == 'bankOrCompanyName') {
    return 'BankOrCompanyName';
  } else if (filed == 'accountNumber') {
    return 'AccountNumber';
  }
  return '';
};
